const NotFound = () => {


  return (
    <h1 className="m-5 text-center text-xl">Oops. The page you are looking for is not found.</h1>
  );
};

export default NotFound;
